(ns app.front.ui.common-tags
  (:require [core.front.carbon :as cc]
            [core.util.util :as util]
            [potpuri.core :as p]
            [schema-tools.core :as st]
            [schema.core :as s]))

(defn tag-size [size]
  (let [button-class (case size
                       :small ["h-6" "px-2" "text-sm"]
                       ["h-10" "px-4"])
        icon-class   (case size
                       :small "h-5 w-5"
                       "")]
    (util/mmap button-class icon-class)))

(def tag-kinds #{:active :passive})
(def tag-sizes #{:normal :small})
(def tag-defaults
  {:size      :normal
   :disabled? false
   :kind      :active})

(s/defschema TagOptions
  (st/merge {:label-text s/Str}
            (st/optional-keys {:classes          [s/Str]
                               :disabled?        s/Bool
                               :size             (s/maybe (apply s/enum tag-sizes))
                               :on-click         s/Any
                               :icon             s/Any
                               :label-classes    [s/Str]
                               :trailing-content s/Any
                               :kind             (s/maybe (apply s/enum tag-kinds))
                               :selected?        s/Bool})))

(s/defn tag
  [opts :- TagOptions]
  (let [{:keys [label-text on-click icon
                classes disabled? size kind label-classes selected? trailing-content]} (merge tag-defaults
                                                                                              (p/remove-vals nil? opts))
        {:keys [button-class icon-class]}                                              (tag-size size)
        icon-class                                                                     (str icon-class
                                                                                            " ml-2 fill-current")]
    [:button.flex.items-center.rounded-full.border-solid
     {:class    (cond-> button-class
                  disabled?              (concat ["pointer-events-none text-ui-gray border-ui-gray"])
                  selected?              (concat ["bg-ui-violet-100 text-ui-white border-transparent"])
                  (= kind :passive)      (concat ["pointer-events-none"])
                  (and (not selected?)
                       (not disabled?))  (concat ["border-ui-violet-100 text-ui-night-sky-100"])
                  true                   (concat ["hover:bg-ui-night-sky-100 hover:text-ui-white hover:border-transparent"])
                  classes                (concat classes))
      :on-click #(do
                   (.preventDefault %) ;; Prevent form submit if this tag is inside a form
                   (when-not (or disabled?
                                 (not (fn? on-click))
                                 (= kind :passive))
                     (on-click %)))}
     [:div.flex-1.font-semibold
      {:class (concat [(case kind
                         :active  "capitalize"
                         :passive "uppercase")]
                      label-classes)}
      label-text]
     trailing-content
     (cond
       (or (fn? icon) (object? icon))
       [:> icon
        {:class-name icon-class}]

       (map? icon)
       [cc/icon {:icon        icon
                 :description label-text
                 :class-name  icon-class}])]))
